import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Grid, Stack, Typography, useMediaQuery } from '@mui/material';

// project imports
import AuthWrapper1 from '../AuthWrapper1';
import AuthCardWrapper from '../AuthCardWrapper';
import AuthLogin from '../auth-forms/AuthLogin';
import Logo from 'ui-component/Logo';
import Footer from 'layout/MainLayout/Footer';

import BG from 'assets/images/Backgrounds/FundoTriunfo.png';

// ================================|| AUTH3 - LOGIN ||================================ //

const Login = () => {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            <AuthWrapper1>
                <Grid container direction="column" justifyContent="center" sx={{ backgroundColor: '#fff' }}>
                    <Grid sx={{ display: 'flex' }}>
                        <Grid item xs={false} lg={4} sm={4}>
                            <Grid container justifyContent="center" alignItems="center">
                                <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                                    <AuthCardWrapper sx={{ border: 'none' }}>
                                        <AuthCardWrapper sx={{ border: 'none' }}>
                                            <Grid container spacing={0} alignItems="center" justifyContent="center">
                                                <Grid item>
                                                    <Logo width={300} height={100} />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid
                                                        container
                                                        direction={matchDownSM ? 'column-reverse' : 'row'}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                    >
                                                        <Grid item>
                                                            <Stack alignItems="center" justifyContent="center" spacing={1}>
                                                                <Typography
                                                                    color="primary"
                                                                    gutterBottom
                                                                    variant={matchDownSM ? 'h3' : 'h2'}
                                                                >
                                                                    Bem vindo de Volta
                                                                </Typography>
                                                                <Typography
                                                                    variant="caption"
                                                                    fontSize="16px"
                                                                    textAlign={matchDownSM ? 'center' : 'inherit'}
                                                                >
                                                                    Entre com suas credenciais para continuar
                                                                </Typography>
                                                            </Stack>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <AuthLogin />
                                                </Grid>
                                            </Grid>
                                        </AuthCardWrapper>
                                    </AuthCardWrapper>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid
                            xs={8}
                            sx={{
                                display: { xs: 'none', lg: 'block' },
                                width: '100%',
                                backgroundImage: 'url(' + BG + ')',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                height: '100vh'
                            }}
                        ></Grid>
                    </Grid>

                    <Footer />
                </Grid>
            </AuthWrapper1>
        </>
    );
};

export default Login;
